import { useState } from "react";

import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDCard from "components/MDCard";
//icons
import { ArrowBack } from "@mui/icons-material";
import {ReactComponent as InfoIcon} from 'assets/images/icons/info.svg'

function WorkspaceCard({ color, icon, title }) {
  const [hover, setHover] = useState(false);
  return (
    <MDCard sx={{minHeight:'5vh'}}>
      <InfoIcon/>
      <MDBox mt={-1} textAlign="center" lineHeight={1.25}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </MDTypography>
        <MDBox p={2} mx={3} display="flex" justifyContent="center">
          <MDBox
            display="grid"
            justifyContent="center"
            alignItems="center"
            bgColor={color}
            color="white"
            width="6rem"
            height="6rem"
            shadow="md"
            borderRadius="lg"
            variant="gradient"
          >
            <Icon fontSize="default">{icon}</Icon>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="end" >
          <MDTypography
            onMouse
            color="info"
            onMouseEnter={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
            sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
              alignItems: "center",
              cursor:'pointer'
            })}
            fontSize="sm"
          >
            ورود به {title}
          </MDTypography>
          <ArrowBack
            sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
              cursor: "pointer",
              fontSize: 8,
              marginLeft: pxToRem(8),
              paddingLeft: hover && pxToRem(8),
              transition: transitions.create(["padding-left"], {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
              }),
            })}
            color="info"
          />
        </MDBox>
      </MDBox>
    </MDCard>
  );
}

// Setting default values for the props of WorkspaceCard
WorkspaceCard.defaultProps = {
  color: "info",
  value: "",
  description: "",
};

// Typechecking props for the WorkspaceCard
WorkspaceCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default WorkspaceCard;
